const fetchWPPageContent = async (path) => {
  const url = `https://eyefitu.ch/${path}/`;

  const response = await fetch(url);

  const [item] = await response.json();

  const title = item.title.rendered;
  const content = item.content.rendered;
  const { meta } = item;

  return {
    title,
    content,
    meta,
  };
};

export default fetchWPPageContent;
